import { Box } from '@mui/material';
import { HOC } from 'formsy-react';
import PropTypes from 'prop-types';
import React from 'react';

import { homeInputErrorSx, marketingFormControlSx, marketingFormGroupSx } from '../../../homeSsrStyles';

function HomeInput({
  getValue,
  setValue,
  _defaultValue,
  _updateImmediately,
  _validations,
  _validationError,
  _validationErrors,
  _value,
  _validationColor,
  requiredError,
  isRequired,
  isPristine,
  isValid,
  isFormSubmitted,
  getErrorMessage,
  _setValidations,
  _resetValue,
  _hasValue,
  _getErrorMessages,
  _isFormDisabled,
  _showRequired,
  _showError,
  _isValidValue,
  ...rest
}) {
  const handleChange = event => {
    setValue(event.currentTarget.value);
  };

  const isRequiredError =
    isRequired() && !isPristine() && !isValid() && isFormSubmitted() && requiredError;
  const errorText = getErrorMessage() || isRequiredError;

  return (
    <Box sx={marketingFormGroupSx}>
      <Box
        component="input"
        sx={marketingFormControlSx}
        value={getValue()}
        onChange={handleChange}
        {...rest}
      />
      {errorText ? <Box component="span" sx={homeInputErrorSx}>{errorText}</Box> : null}
    </Box>
  );
}

HomeInput.defaultProps = {
  placeholder: '',
};

HomeInput.propTypes = {
  placeholder: PropTypes.string,
  getValue: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  getErrorMessage: PropTypes.func.isRequired,
  defaultValue: PropTypes.any,
  name: PropTypes.string.isRequired,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onKeyDown: PropTypes.func,
  requiredError: PropTypes.string,
  underlineFocusStyle: PropTypes.object,
  underlineStyle: PropTypes.object,
  updateImmediately: PropTypes.bool,
  validationColor: PropTypes.string,
  validationError: PropTypes.string,
  validationErrors: PropTypes.object,
  validations: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  value: PropTypes.any,
  isRequired: PropTypes.func.isRequired,
  isPristine: PropTypes.func.isRequired,
  isValid: PropTypes.func.isRequired,
  isFormSubmitted: PropTypes.func.isRequired,
  setValidations: PropTypes.func.isRequired,
  resetValue: PropTypes.func.isRequired,
  hasValue: PropTypes.func.isRequired,
  getErrorMessages: PropTypes.func.isRequired,
  isFormDisabled: PropTypes.func.isRequired,
  showRequired: PropTypes.func.isRequired,
  showError: PropTypes.func.isRequired,
  isValidValue: PropTypes.func.isRequired,
};

export default HOC(HomeInput);
